import { LoadingState } from "types";

export type RelabeledMessage = {
  projectId: number;
  variableFullName?: string;
  errorMessage?: string;
};

export type RelabeledVariablesState = {
  relabeledVariableState: {
    [key: string]: LoadingState;
  };
  relabeledVariableSuccessMessages: RelabeledMessage[];
  relabeledVariableErrorMessages: RelabeledMessage[];
};

export const initialRelabeledVariablesState: RelabeledVariablesState = {
  relabeledVariableState: {},
  relabeledVariableSuccessMessages: [],
  relabeledVariableErrorMessages: [],
};
